import React from 'react';
import NavBurgerMenu from './NavBurgerMenu.js';
import './Nav.css';
import SvgIcon from 'react-icons-kit';

import { navicon } from 'react-icons-kit/ionicons/navicon';




export class NavBurger extends React.Component {
  constructor(props){
    super(props);

    this.state =  {
      showBurgerMenu: false
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e){
    if(this.state.showBurgerMenu === false)
    {
      this.setState({showBurgerMenu: true});
    }
    else{
      this.setState({showBurgerMenu: false});
    }
  }

  render()
  {
    return(
      <div className="NavBurger" >

      <div className="MobileNav">
      <button className={"MobileNavButton " + (this.state.showBurgerMenu ? "navOpen" : '')}  onClick={this.handleClick}>
      <SvgIcon size={40} icon={navicon}/></button>
      </div>
      {this.state.showBurgerMenu === true && <NavBurgerMenu onClick={this.handleClick}  />}
      
      
      </div>


    )
  }
}

export default NavBurger;




// WEBPACK FOOTER //
// ./src/Components/Nav/NavBurger.js